
/* injects from baggage-loader */

import {combineReducers} from 'redux';
import { reducer as formReducer } from 'redux-form';
import UserReducer from './reducerUser';
import SwarmDataReducer from './reducerSwarmData';
import SwarmAsianDataReducer from './reducerSwarmAsianData';
import SwarmConfigDataReducer from './reducerSwarmConfigData';
import CmsDataReducer from './reducerCmsData';
import PersistentUIStateReducer from './reducerPersistentUIState';
import UIStateReducer from './reducerUIState';
import AppReadyReducer from './reducerAppReady';
import PreferencesReducer from './reducerPreferences';
import FavoritesReducer from './reducerFavorites';
import BetslipReducer from './reducerBetslip';
import BetHistoryFiltersReducer from './reducerBetHistoryFilters';
import BetHistoryReducer from "./reducerBetHistory";
import {routerReducer as routing} from 'react-router-redux';
import checkSportsBookView from "../helpers/checkSportsBookView";
import lastAction from "./lastAction";
import TerminalReducer from "./reducerTerminal";
import AsianGamesReducer from "./reducerAsianGames";
import StandartGamesReducer from "./reduserStandartGames";
import GameMarketsListReducer from "./reducerGameMarketsList";
import MatchOfTheDayGamesReducer from "./reduserMatchOfTheDayGames";
import HorseRacingReducer from "./reducerHorseRacing";
import SuperbetInProcess from './reducerSuperbetInProcess';

export const createReducers = (store, geoData) => {
    let additional = {},
        swarmData,
        {isAsian} = checkSportsBookView(false, false, geoData);

    if (isAsian) {
        swarmData = SwarmAsianDataReducer;
    } else {
        swarmData = SwarmDataReducer;
    }

    let reducers = {
        preferences: PreferencesReducer,                // user's preferences
        appReady: AppReadyReducer,                      // application bootstrap state
        user: UserReducer,                              // user data
        swarmData,                                      // main sport/casino data from swarm
        swarmConfigData: SwarmConfigDataReducer,        // config data loaded from swarm (partner , currencies)
        cmsData: CmsDataReducer,                        // data from CMS
        persistentUIState: PersistentUIStateReducer,    // persistent ui state (saved in local storage)
        uiState: UIStateReducer,                        // ui state (not saved)
        favorites: FavoritesReducer,                    // favorites data (game/regionCompetition/market ids)
        betslip: BetslipReducer,                        // betslip data (event ids, mode, etc..)
        betHistoryFilters: BetHistoryFiltersReducer,    // bet history filters data
        betHistory: BetHistoryReducer,                  // bet history
        routing,                                        // Sync router with store
        lastAction,
        terminal: TerminalReducer,
        horseRacing: HorseRacingReducer,
        asianGameList: AsianGamesReducer,
        standartGameList: StandartGamesReducer,
        matchOfTheDayGamesList: MatchOfTheDayGamesReducer,
        superbetInProcess: SuperbetInProcess,
        gameMarketsList: GameMarketsListReducer,
        form: formReducer,                                // redux-form reducer
        ...additional
    };
    return reducers;
};

export const combine = (geoData) => {
    return combineReducers(createReducers(geoData));
};

export default combine();